export default "/images/a61ddaaf263ea6d10535a3d1b5d81fdc.avif";